module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Cookie-e51c9fe450bebd41b7e4d57459abf5c6.svg";